import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const baseURL = import.meta.env.VITE_API_URL;
export const getTokenFromLocalStorage = () => {
  return localStorage.getItem('token');
};

const apis = createApi({
  reducerPath: 'apis',
  baseQuery: fetchBaseQuery({
    baseUrl: `${baseURL}/`,
    mode: 'cors',
  }),
  tagTypes: ['FixedIndicators'],
  endpoints: () => ({}),
});

export default apis;
